import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue, FctValueList } from '../../../../Fct/generics';
export var BuyOnUniswapV2Fork = createPlugin({
    protocol: 'PARASWAP',
    type: 'ACTION',
    method: 'buyOnUniswapV2Fork',
    supportedContracts: [{ address: '0xDEF171Fe48CF0115B1d80b88dc8eAB59176FEe57', chainId: 1 }],
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                methodParams: {
                    tokenIn: new FctAddress({}),
                    amountInMax: new FctValue({}),
                    amountOut: new FctValue({}),
                    weth: new FctAddress({}),
                    pools: new FctValueList({}),
                },
            },
            output: {},
        });
    },
    requiredApprovals: function (params) {
        var _a = params.methodParams, tokenIn = _a.tokenIn, amountInMax = _a.amountInMax;
        return [
            {
                to: tokenIn.value,
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: amountInMax.value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
});
